export enum eBulkMessageSteps {
  LEAD_TYPE = 'LEAD_TYPE',
  TEMPLATE = 'TEMPLATE',
}

export enum eOptionSelected {
  NUMBER = 'NUMBER',
  LIST = 'LIST',
}
